module.exports = __webpack_public_path__ + "static/img/1_3.ab03ade2.jpg";